import script from "./ModuloPredictivo.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuloPredictivo.vue?vue&type=script&setup=true&lang=js"

import "./ModuloPredictivo.vue?vue&type=style&index=0&id=99bd7f0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99bd7f0e"]])

export default __exports__